import { pushToDataLayer } from '../../pushToDataLayer';
import { GTMEvent, GTMEventAttributes, GTMEventName } from '../../types';
import { RecordingToolAction } from './types';

export function recordingToolIntearctionEvent({
  action,
}: {
  action: RecordingToolAction;
}) {
  const eventAttributes: GTMEventAttributes = {
    event: GTMEvent.COVIDEO_EVENT,
    event_name: GTMEventName.RECORDING_TOOL_INTERACTION,
  };

  pushToDataLayer({
    ...eventAttributes,
    type: 'Telepromter',
    action,
  });
}
